import React from 'react';
import { connect } from 'react-redux';
import * as Sentry from '@sentry/browser';
import * as style from './error.css';

const showSentryDialog = (
  sentryId,
  dsn = 'https://bc4e8a5a57da45ff92bc075f0bd06881@sentry.io/148472'
) =>
  Sentry.showReportDialog({
    eventId: sentryId,
    dsn
  });

export const ErrorComponent = ({ errorMessage }) => (
  <div>
    {errorMessage && errorMessage.data ? (
      <div className={style.wrapper}>
        <div>
          <div className={style.errorHeading}>
            Uh-oh! Something went wrong.
            {errorMessage.data.sentryId ? (
              <span>
                &nbsp;
                <button
                  type="button"
                  onClick={() =>
                    showSentryDialog(errorMessage.data.sentryId, errorMessage.data.dsn)
                  }
                >
                  Click here
                </button>
                &nbsp;to provide more details. The code displayed below can be used to track
                the issue.
              </span>
            ) : (
              ''
            )}
          </div>
        </div>
        <div className={style.errorWrapper}>
          <div className={style.sentry}>
            <span>{errorMessage.data.sentryId || ''}</span>
          </div>
          <div className={style.errorMessage}>
            <span>
              {errorMessage.data.exceptionMessage ||
                errorMessage.data.exceptionText ||
                errorMessage.data.message}
            </span>
          </div>
          <div className={style.errorMessage}>
            <span>{errorMessage.url || ''}</span>
          </div>
        </div>
      </div>
    ) : null}
  </div>
);

const mapStateToProps = state => ({
  errorMessage: state.error.error
});
export default connect(mapStateToProps, null)(ErrorComponent);
